import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

import { userScopeCleared } from '@krp/client-runtime'

/**
 * Кассир, выбранный человеком на экране «По кассирам». `null` — человек ещё никого не выбирал: экран предлагает кассира открытой
 * смены (если он есть), иначе просит выбрать. Явный выбор человека всегда сильнее кассира смены. Срок `screen`: после обновления
 * страницы выбор снова начинается с кассира смены.
 */
export interface ChosenCashierState {
  cashierId: string | null
}

export const initialChosenCashier: ChosenCashierState = { cashierId: null }

const chosenSlice = createSlice({
  name: 'schedule/chosen',
  initialState: initialChosenCashier,
  reducers: {
    cashierChosen(state, action: PayloadAction<string>) {
      state.cashierId = action.payload
    },
  },
  extraReducers: (builder) => {
    // Выход или смена человека на устройстве стирает и выбор: следующий человек его не увидит.
    builder.addCase(userScopeCleared, () => initialChosenCashier)
  },
})

export const { cashierChosen } = chosenSlice.actions
export const chosenCashierReducer = chosenSlice.reducer
